import { NgModule, ModuleWithProviders, inject } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { METADATA_TOKEN, FEATURE_NAME, API_PREFIX } from './constants/tokens.constant';
import { EntityManagerConfig } from './entity-manager.model';
import { reducer } from './entity-manager.reducer';
import { CollectionManagerService } from './collection-manager.service';
import { EntityManagerEffect } from './entity-manager.effect';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    HttpClientModule
  ]
})
export class ZefEntitiesModule {

  #metadata = inject(METADATA_TOKEN);
  #collectionManager = inject(CollectionManagerService);

  static forRoot(config?: EntityManagerConfig): ModuleWithProviders<ZefEntitiesModule> {
    return {
      ngModule: ZefEntitiesModule,
      providers: [
        provideState(FEATURE_NAME, reducer),
        provideEffects(EntityManagerEffect),
        {
          provide: METADATA_TOKEN,
          useValue: config?.metadata
        },
        {
          provide: API_PREFIX,
          useValue: config?.config?.apiPrefix || ''
        }
      ]
    };
  }

  constructor() {
    if (this.#metadata) {
      this.#collectionManager.create(this.#metadata);
    }
  }
}
